import { render, staticRenderFns } from "./DiySelect.vue?vue&type=template&id=739b4b3c&scoped=true&lang=html&"
import script from "./DiySelect.vue?vue&type=script&lang=js&"
export * from "./DiySelect.vue?vue&type=script&lang=js&"
import style0 from "./DiySelect.vue?vue&type=style&index=0&id=739b4b3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b4b3c",
  null
  
)

export default component.exports